import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ProductPresentation() {
  const benefits = ['Tortas esponjosas para cumpleaños', 'Tortas clásicas para la merienda', 'Pasteles suaves para celebraciones', 'Tortas caseras que todos quieran repetir'];
  return <section className="py-16 px-4 bg-[#FEF3E2]" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <div className="text-center mb-12 space-y-6" data-id="element-115">
          <p className="text-xl md:text-2xl text-[#3C1518] font-medium" data-id="element-116">
            Con este libro vas a aprender a preparar tortas suaves, altas y
            deliciosas que realmente salen bien.
          </p>
          <p className="text-lg text-[#5C2D0E]" data-id="element-117">
            Recetas explicadas paso a paso.
          </p>
          <p className="text-lg text-[#5C2D0E]" data-id="element-118">
            Sin técnicas complicadas. Sin ingredientes difíciles de conseguir.
            Sin pasos confusos.
          </p>
          <p className="text-xl font-bold text-[#C2410C]" data-id="element-119">
            Solo recetas probadas que funcionan.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-[#E8D5C0] shadow-xl" data-id="element-120">
          <h3 className="text-2xl font-bold text-[#3C1518] mb-8 text-center" data-id="element-121">
            Imaginá poder preparar en casa:
          </h3>
          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-122">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-123">
                <CheckCircle2 className="w-6 h-6 text-[#C2410C] flex-shrink-0 mt-1" data-id="element-124" />
                <span className="text-lg text-[#5C2D0E]" data-id="element-125">{benefit}</span>
              </li>)}
          </ul>
          <p className="text-center text-[#92400E] mt-8 italic" data-id="element-126">
            Todo explicado de forma simple.
          </p>
        </div>
      </div>
    </section>;
}